import { render, staticRenderFns } from "./PublishedLegalDocument.vue?vue&type=template&id=27550dfc&scoped=true"
import script from "./PublishedLegalDocument.vue?vue&type=script&lang=js"
export * from "./PublishedLegalDocument.vue?vue&type=script&lang=js"
import style0 from "./PublishedLegalDocument.vue?vue&type=style&index=0&id=27550dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27550dfc",
  null
  
)

export default component.exports